import { useLayoutEffect } from 'react';

/**
 * useBrandScope — sets `data-brand` on <html> for the life of the page, so
 * the generated theme (`:root[data-brand]`) and every DS component switch to
 * that brand, and restores whatever was there before on unmount.
 *
 * A layout effect: the attribute is set before the first paint, so a page
 * reached from another brand's route never flashes the other brand's theme.
 *
 * @param {'CLS'|'ABC'|'Overall'|'Crownstudent'} brand
 */
export default function useBrandScope(brand) {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const prev = root.getAttribute('data-brand');
    root.setAttribute('data-brand', brand);
    return () => {
      if (prev) root.setAttribute('data-brand', prev);
      else root.removeAttribute('data-brand');
    };
  }, [brand]);
}
